// extracted by mini-css-extract-plugin
export default {"section-wrapper":"Info_section-wrapper__DtGMX"};